var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-md-row"},[_c('v-sheet',{attrs:{"width":"100%"}},[_c('SearchField'),(_vm.categoryId)?_c('ProductCategorySelect'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }